import './style.css'
import './vintage.css'
import { GameApp } from './game/app.js'

const canvas = document.querySelector('canvas.webgl')
const ui = document.querySelector('#ui')

const app = new GameApp({ canvas, ui })

if (import.meta.env.DEV) {
    window.__game = app
    import('./game/dev/balance-lab.js').then(({ runBalanceLab }) => {
        window.__balance = (options) => runBalanceLab(app, options)
    })
}
